// src/components/listing/ListingGrid.js
// Grille d'affichage des annonces - NE PAS MODIFIER

import React from 'react';
import { useTranslation } from 'react-i18next';
import ListingCard from './ListingCard';
import LoadingSpinner from '../shared/LoadingSpinner';

const ListingGrid = ({ listings = [], loading = false, emptyMessage = null }) => {
  const { t } = useTranslation();

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 16px',
    },
    emptyContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      textAlign: 'center',
      gap: '12px',
    },
    emptyIcon: {
      fontSize: '48px',
      opacity: 0.5,
    },
    emptyText: {
      fontSize: '14px',
      color: '#A0AEC0',
    },
  };

  if (loading) {
    return <LoadingSpinner size="medium" message={t('common.loading')} />;
  }

  if (!listings || listings.length === 0) {
    return (
      <div style={styles.emptyContainer}>
        <div style={styles.emptyIcon}>🔍</div>
        <div style={styles.emptyText}>
          {emptyMessage || t('home.noResults')}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {listings.map((listing) => (
        <ListingCard key={listing.id} listing={listing} />
      ))}
    </div>
  );
};

export default ListingGrid;